module.exports = __webpack_public_path__ + "static/media/Andrei_Kurkin.9b20d23e.jpg";